import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more_icon_jax_27db0c2b0c46601acb8f467fa7f05003",
  "use": "more_icon_jax_27db0c2b0c46601acb8f467fa7f05003-usage",
  "viewBox": "0 0 25 7",
  "content": "<symbol viewBox=\"0 0 25 7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"more_icon_jax_27db0c2b0c46601acb8f467fa7f05003\"><g transform=\"translate(1 1)\" fill=\"none\"><circle cx=\"20.5\" cy=\"2.5\" r=\"2.5\" /><circle cx=\"11.5\" cy=\"2.5\" r=\"2.5\" /><circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol